/**
 * Website-template media helpers — same split/video rules as LiB feeds.
 */

import {
  isLikelyImageUrl,
  isLikelyVideoUrl,
  splitMediaUrls,
} from "../../../Utils/media/feedMedia";

/** Commas inside a signed/CDN URL must not become extra slides. */
export function splitTemplateMediaUrls(raw: string): string[] {
  return splitMediaUrls(raw).slice(0, 10);
}

export function isTemplateCarouselSlideVideo(
  url: string,
  playableVideoUrl?: string,
): boolean {
  if (isLikelyVideoUrl(url)) return true;
  const playable = String(playableVideoUrl || "").trim();
  return Boolean(playable) && playable === url && !isLikelyImageUrl(url);
}
